import { Controller } from "@hotwired/stimulus"

// Color picker controller for task form
export default class extends Controller {
  static targets = ["input", "preview", "hex"]

  connect() {
    this.updatePreview()
  }

  updatePreview() {
    const color = this.inputTarget.value
    if (this.hasPreviewTarget) {
      this.previewTarget.style.backgroundColor = color
    }
    if (this.hasHexTarget) {
      this.hexTarget.textContent = color.toUpperCase()
    }
  }

  reset(event) {
    event.preventDefault()
    const defaultColor = event.currentTarget.dataset.colorPickerDefaultValue || "#009C72"
    this.inputTarget.value = defaultColor
    this.updatePreview()
  }
}
